<template>

    <div>

        <transition name="modal">
            <workplace-modal
                :workplace_id="modal_workplace_id"
                @close="() => {
                    modal_workplace_id = null
                    refresh()
                }"
                v-if="modal_workplace_id"
            />
        </transition>

        <h2 class="mb-2">Arbetsplatser</h2>
        <div class="custom-info pt-0 mb-0" style="max-width: 1000px;">Här skapar och hanterar du företagets arbetsplatser och kontaktpersoner. I denna lista lägger du även in bokningskalendrar och annan nödvändig information, om företaget erbjuder massage på arbetsplatsen.
        </div>

        <div class="row mb-4">
            <div class="col d-flex justify-content-end">
                <button class="btn btn-primary btn-sm mr-2" @click="createWorkplace()">Lägg till arbetsplats
                    <div class="tooltip-label">Lägg till en arbetsplats.</div>
                </button>
            </div>
        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">

                <div class="row g-3">

                    <div class="col-4 align-items-start">
                        <span>{{ props.item.title }}</span>
                    </div>
                    <div class="col-11 align-items-start">
                        <div class="row">
                            <div class="col d-block" :key="'cw'+contact.id" v-for="contact in props.item.contacts">
                                <span v-if="contact.name">{{ contact.name }}<br></span>
                                <span v-if="contact.title">{{ contact.title }}<br></span>
                                <span v-if="contact.email"><a :href="'mailto:'+contact.email">{{ contact.email }}</a><br></span>
                                <span v-if="contact.phone_1"><a :href="'tel:'+contact.phone_1">{{ contact.phone_1 }}</a><br></span>
                                <span v-if="contact.phone_2"><a :href="'tel:'+contact.phone_2">{{ contact.phone_2 }}</a><br></span>

                            </div>
                        </div>
                    </div>
                    <div class="col-3 align-items-start">
                        <span class="fa fa-check" v-if="props.item.is_selectable"></span>
                    </div>
                    <div class="col-4 align-items-start">
                        <span class="fa fa-check" v-if="props.item.booking_is_active"></span>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <button @click="modal_workplace_id = props.item.id" class="btn btn-primary btn-sm">Hantera</button>
                    </div>
                </div>
            </div>
        </list>

    </div>

</template>

<script>
import workplaceModal from '../workplaces/modal.vue'

import lister from '../../../../shared/mixins/lister'
import axios from 'axios'

export default {

    mixins: [
        lister
    ],

    components: {
        workplaceModal
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            modal_workplace_id: null,
            settings: {
                url: '/companies/' + this.company_id + '/workplaces/list',
                query: {
                    text: ''
                },
                columns: [
                    { column: 'title', name: 'Kontor', class: 'col-4', sortable: true, default: true },
                    { column: 'name', name: 'Kontaktpersoner', class: 'col-11', sortable: false },
                    { column: 'is_selectable', name: 'Visa för anställda', class: 'col-3', sortable: true },
                    { column: 'booking_is_active', name: 'Bokningskalender', class: 'col-4', sortable: true }
                ],
                bulk_actions: []
            }
        }
    },

    methods: {
        createWorkplace () {
            axios.post('/companies/' + this.company_id + '/workplaces')
                .then(response => {
                    this.modal_workplace_id = response.data.workplace_id
                })
        }
    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 350ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 500ms ease;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}
</style>
